import { Navigate, RouteObject } from 'react-router-dom';
import MovementsLayout from '../layouts/MovementsLayout';
import { MovementsOverviewPage } from '../pages/MovementsOverviewPage';
import RequirePermissionRoute from '@/components/permissions/RequirePermissionRoute';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

export const MOVEMENT_ROUTES: RouteObject[] = [
  {
    path: 'movements',
    element: <MovementsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />,
      },
      {
        path: 'overview',
        element: (
          <RequirePermissionRoute requiredPermission={Permission.MOVEMENTS_VIEW}>
            <MovementsOverviewPage />
          </RequirePermissionRoute>
        ),
      },
    ],
  },
];
